import { AccessRoleCodes } from "Models/AccessRoleCodes";
import { Resources, type TFunction } from "Translations/Resources";

const RESOURCES = Resources.User.AccessRole;

// For lists backed by the Identity-aware role filter (HasAnyRole): business roles match any
// held grant, while Customer means retail-only — the label must say so, since every personal Identity
// carries the Customer baseline and "User" alone would read as "everyone" (only single-grant
// back-office accounts have no Customer grant).
export const getIdentityRoleFilterOptions = (
  t: TFunction,
): Array<{ label: string; value: string }> => [
  { label: t(RESOURCES.Hunter), value: AccessRoleCodes.Hunter },
  { label: t(RESOURCES.HunterPlus), value: AccessRoleCodes.HunterPlus },
  {
    label: t(Resources.User.RoleFilter.CustomerOnly),
    value: AccessRoleCodes.Customer,
  },
  { label: t(RESOURCES.Merchant), value: AccessRoleCodes.Merchant },
];
